export default "__VITE_ASSET__BVYhQdrc__"